import './instance';
Oskari.bundle('file-upload', function () {
  return Oskari.clazz.create('Oskari.file-upload.BundleInstance');
});